import React, { ReactNode, useState } from 'react';
import { ChevronDown } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import cn from 'classnames';
import styles from './styles.module.scss';

type NotificationMessageType = 'warning' | 'danger' | 'notice' | 'psp';

interface IProps {
  title: string;
  type: NotificationMessageType;
  useRollUp: boolean;
  listItems?: Array<string | JSX.Element> | null;
  icon?: ReactNode;
  isDecimalListType?: boolean;
  isSpacePreWrap?: boolean;
}

export const NotificationMessage: React.FC<IProps> = (props) => {
  const { i18n } = useTranslation();
  const { title, listItems, icon, useRollUp, type, isDecimalListType, isSpacePreWrap = true } = props;
  const [rolledUp, setRolledUp] = useState<boolean>(useRollUp);

  const onClickHandler = () => {
    setRolledUp(!rolledUp);
  };

  const listTypeClassName = isDecimalListType ? styles.notification__decimal : styles.notification__bullet;

  const getItems = () =>
    listItems &&
    listItems.map((item) => (
      <div key={item.toString()} className={styles.notification__item}>
        <div className={listTypeClassName} />
        <li>{renderItem(item)}</li>
      </div>
    ));

  const renderItem = (item: string | JSX.Element) => {
    if (typeof item === 'object') {
      return item;
    }
    return i18n.t(item as KeyMapKeys);
  };

  return (
    <div className={cn(styles.notification, styles[type])}>
      <div className={styles.notification__header}>
        <div className={styles.notification__icon}>{icon}</div>

        <span
          className={cn(styles.notification__title, {
            [styles.notification__title_spacePreWrap]: isSpacePreWrap,
          })}>
          {i18n.t(title as KeyMapKeys)}
        </span>
      </div>
      <div className={cn(styles.notification__body, !rolledUp && styles.fullHeight)}>
        <ul className={styles.notification__list}>{getItems()}</ul>
      </div>
      {useRollUp && (
        <div className={styles.notification__footer} onClick={onClickHandler}>
          <ChevronDown className={cn(styles.notification__chevron, !rolledUp && styles.isOpened)} />
        </div>
      )}
    </div>
  );
};
